/** Parse a formatted metric value (e.g. "8.2K", "2.3%", 42) into a raw number for sorting/comparison */
export const parseNumericValue = (val: string | number): number => {
  if (typeof val === 'number') return val;
  const stripped = val.replace('%', '').trim();
  if (stripped.endsWith('K')) {
    return parseFloat(stripped.slice(0, -1)) * 1_000 || 0;
  }
  if (stripped.endsWith('M')) {
    return parseFloat(stripped.slice(0, -1)) * 1_000_000 || 0;
  }
  return parseFloat(stripped) || 0;
};

/** Calculate the width percentage of a progress bar relative to the maximum value in the dataset */
export const getBarWidthPercent = (value: string | number, maxValue: number): number => {
  if (maxValue === 0) return 0;
  const numeric = parseNumericValue(value);
  return Math.max(0, Math.min(100, (numeric / maxValue) * 100));
};
